import { Component, OnInit } from '@angular/core';
import { embedDashboard } from '@superset-ui/embedded-sdk';
import { SupersetEmbeddedService } from 'src/app/services/superset-embedded.service';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { SupersetDashboardService } from 'src/app/services/superset-dashboard.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-analytics-purchases',
  templateUrl: './analytics-purchases.component.html',
  styleUrls: ['./analytics-purchases.component.scss']
})
export class AnalyticsPurchasesComponent implements OnInit {
  private supersetUrl = 'https://graph.servicios.gt/';
  private dashboardId = 2;
  private dashboardOriginalId = '';
  start = new Date().toLocaleDateString('en-CA');
  end = new Date().toLocaleDateString('en-CA');
  loading = false;

  constructor(private supersetService: SupersetEmbeddedService,
    private authenticationService: AuthenticationService,
    private supersetDashboardService: SupersetDashboardService,
    private toastService: ToastrService
  ) {

  }

  ngOnInit(): void {
    const today = new Date();

    // Primer día del mes
    const firstDay = new Date(
      today.getFullYear(),
      today.getMonth(),
      1
    );

    // Último día del mes
    const lastDay = new Date(
      today.getFullYear(),
      today.getMonth() + 1,
      0
    );

    this.start = firstDay.toLocaleDateString('en-CA');
    this.end = lastDay.toLocaleDateString('en-CA');

    this.getDashboardSdk();
  }

  getDashboardSdk() {
    this.supersetDashboardService.getDashboard(this.dashboardId).subscribe({
      next: (response: any) => {
        this.dashboardOriginalId = response.data.sdkId;

        if (!this.dashboardOriginalId) {
          console.error('No se recibió sdkId del dashboard');
          return;
        }

        this.loadDashboard();
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      }
    });
  }

  loadDashboard(): void {
    if (!this.dashboardOriginalId) {
      console.error('No se recibió sdkId del dashboard');
      return;
    }

    if (!this.start || !this.end) {
      this.toastService.warning('Las fechas no son correctas');
      return;
    }

    const mountPoint = document.getElementById('superset_embedding_div_class');

    if (!mountPoint) {
      console.error('No se encontró el contenedor de Superset');
      return;
    }

    const [year, month, day] = this.end.split('-').map(Number);

    const endDate = new Date(year, month - 1, day);
    endDate.setDate(endDate.getDate() + 1);

    const dateTo = endDate.toLocaleDateString('en-CA');

    this.loading = true;
    embedDashboard({
      id: this.dashboardOriginalId,
      supersetDomain: this.supersetUrl,
      mountPoint,
      fetchGuestToken: () =>
        new Promise((resolve, reject) => {
          this.supersetService.getGuest(this.dashboardId).subscribe({
            next: (response: any) => { resolve(response.data.token); this.loading = false; },
            error: err => { reject(err); this.loading = false; }
          });
        }),
      dashboardUiConfig: {
        hideTitle: true,
        hideChartControls: true,
        hideTab: true,
        filters: {
          visible: false,
          expanded: false
        },
        urlParams: {
          company_id: this.authenticationService.getCurrentCompanyId(),
          date_from: this.start,
          date_to: dateTo
        }
      }
    });
  }
}
